<template>
    <div>
        <div
            @click.self="isOpenedRequestDropdown = false"
            class="poi-modal__row"
        >
            <p class="poi-modal__text">
                {{ addGroupModal.textGroupName }}
                <span style="color: red">*</span>
            </p>
            <base-text-input
                view="primary"
                :placeholder="addGroupModal.textGroupNamePlaceholder"
                v-model.trim="groupName"
            />
        </div>

        <slot name="icons" />

        <div class="poi-modal__actions">
            <LinceButton
                class="poi-modal__cancel"
                :view="'square'"
                :theme="'border'"
                @click="onCloseModal"
                >{{ addGroupModal.textCancel }}</LinceButton
            >
            <LinceButton
                :view="'square'"
                :theme="'secondary'"
                :disabled="isDisabled"
                @click="onApply"
                >{{ addGroupModal.textApply }}</LinceButton
            >
        </div>
    </div>
</template>

<script>
import BaseTextInput from "@/components/Base/BaseTextInput";
import containerPoiSchemes from "../../schemes/SchemeWidgetMap";
const { containerPoi } = containerPoiSchemes;

export default {
    name: "AddEmptyPoiModalContent",
    components: {
        
        BaseTextInput,
    },
    data: () => ({
        addGroupModal: containerPoi.addGroupModal,
        groupName: "",
    }),

    computed: {
        isDisabled() {
            return this.groupName.length === 0;
        },
    },

    methods: {
        onInput(value) {
            this.groupName = value;
        },
        onApply() {
            const requestCreateGroupParams = {
                name: this.groupName,
                request_id: "1",
                request_item_ids: ["1"],
            };
            this.$emit("onCreateNewEmptyGroup", requestCreateGroupParams);
        },
        onCloseModal() {
            this.$emit("onCloseModal");
        },
    },
};
</script>
